import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateFolderName } from '../MemberBins/actions/FoldersActions';
import {
  selectBinUniqueId,
  selectMemberBinBinName,
  selectMemberBinName,
} from '../MemberBins/selectors/foldersSelectors';

import './EditableFolderTitle.less';

interface Props {
  binName: string;
  binUniqueId: string;
  name: string;
  updateFolderName: (folderUniqueId: string, name: string) => void;
}

interface State {
  isEditingName: boolean;
  isHovering: boolean;
}

class EditableFolderTitle extends Component<Props, State> {
  state = {
    isEditingName: false,
    isHovering: false,
  };

  render() {
    if (this.state.isEditingName) {
      return this.renderEditBar();
    } else if (this.state.isHovering) {
      return this.renderTitleBarHovering();
    } else {
      return this.renderTitleBarNotHovering();
    }
  }

  renderTitleBarNotHovering() {
    return (
      <div className="editableFolderTitle">
        <h1
          className="editableFolderTitle-title"
          onKeyDown={this.startEditingHandler()}
          onClick={this.startEditingHandler()}
          onFocus={this.hoverOverHandler()}
          onMouseEnter={this.hoverOverHandler()}
          onBlur={this.hoverOffHandler()}
          onMouseLeave={this.hoverOffHandler()}
        >
          {this.props.binName}
        </h1>
      </div>
    );
  }

  renderTitleBarHovering() {
    return (
      <div className="editableFolderTitle">
        <h1
          className="editableFolderTitle-title"
          onKeyDown={this.startEditingHandler()}
          onClick={this.startEditingHandler()}
          onFocus={this.hoverOverHandler()}
          onMouseEnter={this.hoverOverHandler()}
          onBlur={this.hoverOffHandler()}
          onMouseLeave={this.hoverOffHandler()}
        >
          {this.props.binName}
        </h1>
        <img
          alt="Edit"
          src={__ASSETS_COMMON_IMAGES_URL__ + '/member/folders/sb-edit.svg'}
          className="editableFolderTitle-pencil"
          width={25}
          height={24}
        />
      </div>
    );
  }

  renderEditBar() {
    return (
      <div className="editableFolderTitle">
        <input
          type="text"
          className="editableFolderTitle-inputBar"
          onBlur={(event) => {
            this.saveFolderNameHandler(event);
          }}
          onKeyPress={(event) => {
            event.key === 'Enter' && this.saveFolderNameHandler(event);
          }}
          defaultValue={this.props.binName}
        />
      </div>
    );
  }

  startEditingHandler() {
    return () => {
      this.setState({
        isEditingName: true,
      });
    };
  }

  hoverOverHandler() {
    return () => {
      this.setState({
        isHovering: true,
      });
    };
  }

  hoverOffHandler() {
    return () => {
      this.setState({
        isHovering: false,
      });
    };
  }

  saveFolderNameHandler(event) {
    this.setState({
      isEditingName: false,
      isHovering: false,
    });

    const newFolderName = event.currentTarget.value;
    if (newFolderName !== this.props.name && newFolderName !== '') {
      this.props.updateFolderName(this.props.binUniqueId, newFolderName);
    }
  }
}

function mapStateToProps(state) {
  return {
    binName: selectMemberBinBinName(state),
    binUniqueId: selectBinUniqueId(state),
    name: selectMemberBinName(state),
  };
}

export default connect(mapStateToProps, { updateFolderName })(
  EditableFolderTitle
);
